// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>2</span>&nbsp;&nbsp;Whoever leads an uncorrupt life&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;and does the thing that is right;<br> </p> </div></div>";
// Exports
module.exports = code;